import styles from './Solutions.module.scss';
import classNames from 'classnames/bind';
import Solutions from '../../assets/solutions.jpg';
import { useInView } from 'react-intersection-observer';

const cx = classNames.bind(styles);

function AboutUs() {
    const { ref, inView } = useInView({
        /* Optional options */
        threshold: 0,
        triggerOnce: true,
    });
    return (
        <section className={cx('section')}>
            <div className={cx('container')} ref={ref}>
                <div className={cx('content')}>
                    <div className={cx(['text-container', { 'animation': inView }])}>
                        <h2>
                            Delivering
                            <strong> remarkable </strong>
                            solutions
                        </h2>
                        <p>
                            In order to create immersive experiences we need to ensure our team is technically capable of analysing, understanding & ultimately delivering to your business challenges. We can work on your technology needs from ideation to globalisation.
                        </p>
                    </div>
                    <div className={cx(['image-container', { 'animation': inView }])}>
                        <img src={Solutions} alt="Eronka Solutions"></img>
                    </div>
                </div>
            </div>
        </section>
    );
}
  
export default AboutUs;